import { faSave } from "@fortawesome/free-solid-svg-icons";
import auth from "../../../../Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import withValueField from "../../../../Shared/withValueField";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import * as React from "react";
import { clientRateCardValidation, clientRateCardValidationWithAll, clientRateCardValidationWithDivLocAll, clientRateCardValidationWithPosAll } from "./validations/rateValidations";
import { errorToastr, successToastr, toLocalDateTime } from "../../../../../HelperMethods";
import { ErrorComponent } from "../../../../ReusableComponents";
import { IDropDownModel } from "../../../../Shared/Models/IDropDownModel";
import { filterBy } from "@progress/kendo-data-query";
import Skeleton from "react-loading-skeleton";
import commonService from "../../../../Shared/Services/CommonDataService";
import globalAdminService from "../../../GlobalAdmin/Service/DataService";
import clientAdminService from "../../Service/DataService";
import { CLIENT_RATE_CARD_UPDATE_SUCCESS_MSG } from "../../../../Shared/AppMessages";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Form } from "reactstrap";
import { Formik } from "formik";
import axios from "axios";
import TagControl from "../../../../Shared/TagControl/TagControl";
import { AllRateCard, BillTypeFilters, BillTypeIntIds, EntityTypeId, LocalizationResource } from "../../../../Shared/AppConstants";
import { LocalizationHelper } from "../../../../../Localization/helpers/LocalizationHelper";

const CustomDropDownList = withValueField(DropDownList);
const defaultItem = { name: "Select..", id: null };

export interface EditClientRateCardProps {
    props: any;
    onCloseModal: any;
    onOpenModal: any;
}

export interface EditClientRateCardState {
    clientId?: string;
    clientName: string;
    divisionId?: string;
    locationId?: string;
    jobCategoryId?: string;
    positionId?: string;
    division?: string;
    location?: string;
    jobCategory?: string;
    position?: string;
    shiftId?: string;
    serviceCategoryId?: string;
    serviceTypeId?: string;
    billTypeId?: string;
    rateCardId?: string;
    maxBillRate?: number;
    suppress?: number;
    supressionAmount?: number;
    maxHolidayBillRate?: number;
    validFrom?: Date;
    validTo?: Date;
    submitted: boolean;
    showLoader?: boolean;
    divisions: Array<IDropDownModel>;
    locations: Array<IDropDownModel>;
    jobCategories: Array<IDropDownModel>;
    positions: Array<IDropDownModel>;
    serviceCategory: Array<IDropDownModel>;
    serviceTypes: Array<IDropDownModel>;
    billTypes: Array<IDropDownModel>;
    originalbillTypes: Array<IDropDownModel>;
    isDirty?: boolean;
    addNew?: boolean;
    suppressionAmount?: number;
}

class EditClientRateCard extends React.Component<EditClientRateCardProps, EditClientRateCardState> {
    public targetRate: any;
    constructor(props: EditClientRateCardProps) {
        super(props);
        this.state = {
            clientId: auth.getClient(),
            clientName: auth.getClientName(),
            divisions: [],
            locations: [],
            jobCategories: [],
            positions: [],
            billTypes: [],
            originalbillTypes: [],
            serviceCategory: [],
            serviceTypes: [],
            suppress: 0,
            showLoader: true,
            submitted: false,
            isDirty: false,
            validFrom: new Date(),
            validTo: new Date(new Date().setDate(new Date().getDate() + 1)),
            suppressionAmount: 0,
        };
        this.handleFilterChange = this.handleFilterChange.bind(this);
    }

    componentDidMount() {
        this.getDivisions();
        this.getJobCategory();
        this.getServiceCategories();
        this.getBillTypes(BillTypeFilters.ALLBILLTYPES);
        if (this.props.props) {
            this.targetRate = this.props.props.targetRate
            this.setState({
                rateCardId: this.props.props.rateCardId,
                divisionId: this.props.props.divisionId,
                locationId: this.props.props.locationId,
                jobCategoryId: this.props.props.jobCategoryId,
                positionId: this.props.props.clientPosId,
                division: this.props.props.division,
                location: this.props.props.location,
                position: this.props.props.position,
                jobCategory: this.props.props.jobCategoryId==null ? AllRateCard.NAME.toString():"",
                serviceCategoryId: this.props.props.serviceCategoryId,
                serviceTypeId: this.props.props.serviceTypeId,
                billTypeId: this.props.props.billTypeId,
                maxBillRate: this.props.props.maxBillRate,
                suppress: this.props.props.suppressPer == null ? 0 : this.props.props.suppressPer,
                suppressionAmount: this.props.props.suppressionRate == null ? 0 : this.props.props.suppressionRate,
                maxHolidayBillRate: this.props.props.maxHolidayBillRate,
                validFrom: this.props.props.validFrom,
                validTo: this.props.props.validTo
            }, () => {
                (this.state.divisionId || this.state.division==AllRateCard.NAME) && this.getLocations(this.state.divisionId);
                (this.state.jobCategoryId || this.state.jobCategory==AllRateCard.NAME) && this.getPositions(this.state.jobCategoryId);
                this.state.serviceCategoryId && this.getServiceTypes(this.state.serviceCategoryId)
            })
        }
    }

    getDivisions = () => {
        const { clientId } = this.state;
        let queryParams = `status eq 'Active'&$orderby=name`;
        if (this.props.props && this.props.props.divisionId) {
            queryParams = `status eq 'Active' or id eq ${this.props.props.divisionId} &$orderby=name `;
        }
        commonService.getClientDivision(clientId, queryParams).then((res) => {
            res.data.unshift({
                    name: AllRateCard.NAME,
                    id: AllRateCard.ID,
                  });
            this.setState({ divisions: res.data, showLoader: false }, () => {
                if (document.getElementsByName('validFrom')) {
                    document.getElementsByName('validFrom')[0]['disabled'] = true;
                }
            });
        });
    }

    getLocations = (Id) => {
        if(Id ==null)
        {
            if(this.state.division==AllRateCard.NAME && this.state.location==AllRateCard.NAME){
                    this.setState({locations: [{name: AllRateCard.NAME.toString(),id: AllRateCard.ID.toString()}]});
                }
                return;
        }
        let queryParams = `status eq 'Active' and divId eq ${Id} &$orderby=name`;
        if (this.props.props && this.props.props.locationId) {
            queryParams = `(status eq 'Active' or id eq ${this.props.props.locationId}) and divId eq ${Id}&$orderby=name `;
        }
        commonService.getDivisionLocations(queryParams).then((res) => {
            this.setState({ locations: res.data });
        });
    }

    handleDropdownChange = (e) => {
        let change = { isDirty: true };
        change[e.target.props.name] = e.target.value;
        this.setState(change);
    }

    getJobCategory = () => {
        const { clientId } = this.state;
        const queryParams = `status eq 'Active'&$orderby=name`;
        globalAdminService.getClientPositionCategories(clientId, queryParams)
            .then(async res => {
                res.data.unshift({
                    name: AllRateCard.NAME,
                    id: AllRateCard.ID,
                  });
                this.setState({ jobCategories: res.data });
            });
    }

    getPositions = (Id) => {
        if(Id ==null)
        {
            if(this.state.jobCategory==AllRateCard.NAME && this.state.position==AllRateCard.NAME){
                    this.setState({positions: [{name: AllRateCard.NAME.toString(),id: AllRateCard.ID.toString()}]});
                }
                return;
        }
        axios.get(`api/clients/${this.state.clientId}/jobcategories/${Id}/jobpositions?$orderby=name`)
            .then(async res => {
                this.setState({ positions: res.data });
            });
    }

    getServiceCategories = () => {
        axios.get(`api/candidates/servicecat?$orderby=name`).then((res) => {
            this.setState({ 
                serviceCategory: res.data
             });
        });
    }

    getServiceTypes = (Id) => {
        axios.get(`api/admin/servicetypes?$filter=serviceCatId eq ${Id}&$orderby=name`)
            .then(async res => {
                this.setState({ serviceTypes: res.data });
            });
    }

    getBillTypes = (BillTypeFilter) => {
        if(BillTypeFilter == BillTypeFilters.ALLBILLTYPES){
            this.setState({ billTypeId: null })
            axios.get(`api/admin/billtypes?$filter=intId ne ${BillTypeIntIds.ONETIME}`)
                .then(async res => {
                    this.setState({ billTypes: res.data, originalbillTypes: res.data });
                });
        }else{
            this.setState({ billTypeId: null })
            axios.get(`api/admin/billtypes?$filter=intId eq ${BillTypeIntIds.ONETIME}`)
                .then(async res => {
                    this.setState({ billTypes: res.data, originalbillTypes: res.data });
                });
        }
    }

    handleFilterChange(event) {
        var name = event.target.props.id;
        var originalArray = "original" + name;
        this.state[name] = this.filterData(event.filter, originalArray);
        this.setState(this.state);
    }

    filterData(filter, originalArray) {
        const data1 = this.state[originalArray];
        return filterBy(data1, filter);
    }

    openNew = () => {
        this.props.onOpenModal();
    };
    getValidationSchema=()=>{
        
        if(this.state.division==AllRateCard.NAME && this.state.location==AllRateCard.NAME
            && this.state.jobCategory==AllRateCard.NAME && this.state.position==AllRateCard.NAME
        )
        {
            return clientRateCardValidationWithAll;
        }
        else if(this.state.division==AllRateCard.NAME && this.state.location==AllRateCard.NAME)
        {
            return clientRateCardValidationWithDivLocAll;
        }
        else if(this.state.jobCategory==AllRateCard.NAME && this.state.position==AllRateCard.NAME)
        {
            return clientRateCardValidationWithPosAll;
        }
        else{
            return clientRateCardValidation;
        }
    }

    saveClientRateCard(isSubmit: boolean) {
        let data = {
            rateCardId: this.state.rateCardId,
            clientId: this.state.clientId,
            divisionId: this.state.divisionId,
            locationId: this.state.locationId,
            positionId: this.state.positionId,
            serviceTypeId: this.state.serviceTypeId,
            billTypeId: this.state.billTypeId,
            maxBillRate: this.state.maxBillRate,
            suppress: this.state.suppress.toFixed(2),
            suppressionRate: this.state.suppressionAmount.toFixed(2),
            targetRate: this.targetRate,
            maxHolidayBillRate: this.state.maxHolidayBillRate,
            validFrom: toLocalDateTime(this.state.validFrom)
        };
        data["isSubmit"] = isSubmit;
        if (this.state.rateCardId) {
            const { rateCardId } = this.state;
            clientAdminService.putClientRateCard(rateCardId, data).then((res) => {
                if (res.data && !res.data.isSuccess) {
                    errorToastr(res.data.statusMessage);
                } else {
                    successToastr(CLIENT_RATE_CARD_UPDATE_SUCCESS_MSG);
                    this.props.onCloseModal();
                }
            });
        }
    }
    render() {
        const perc = (this.state.suppress / 100) * this.state.maxBillRate;
        const supressionAmount = this.state.maxBillRate - perc;
        this.targetRate = supressionAmount.toFixed(2);
        return (
            <div className="row mt-0 ml-0 mr-0 mt-lg-0 align-items-center mb-0 d-flex justify-content-end holdposition-width">
                <div className="modal-content border-0">
                    <div className="modal-header rounded-0 bg-blue d-flex justify-content-center align-items-center pt-2 pb-2">
                        <h4 className="modal-title text-white fontFifteen">
                            {this.props.props !== undefined ? "Edit" : "Add New"} Rate
                        </h4>
                        <button type="button" className="close text-white close_opacity" data-dismiss="modal" onClick={this.props.onCloseModal}>
                            &times;
                        </button>
                    </div>
                    <Formik
                        validateOnMount={this.state.submitted}
                        initialValues={this.state}
                        validateOnChange={false}
                        enableReinitialize={true}
                        validationSchema={this.getValidationSchema}
                        validateOnBlur={false}
                        onSubmit={(fields) => this.saveClientRateCard(true)}
                        render={(formikProps) => (
                            <Form onSubmit={(e) => { e.preventDefault(); formikProps.handleSubmit(); }} className="col-12 ml-0 mr-0" id="collapsiblePadding" onChange={formikProps.handleChange}>
                                {this.state.showLoader &&
                                    Array.from({ length: 5 }).map((item, i) => (
                                        <div className="row mx-auto mt-2" key={i}>
                                            {Array.from({ length: 3 }).map((item, j) => (
                                                <div className="col-12 col-sm-4 col-lg-4 mt-sm-0  mt-1" key={j}>
                                                    <Skeleton width={230} />
                                                    <Skeleton height={30} />
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                {!this.state.showLoader && (
                                    <div>
                                        <div className="row mt-2 mx-0">
                                            <div className="col-sm-4">
                                                <label className="mb-0 font-weight-bold">Client</label>
                                                <input
                                                    type="text"
                                                    className="form-control mt-1"
                                                    disabled={true}
                                                    value={this.state.clientName}
                                                />
                                            </div>
                                            <div className="col-12 col-sm-4 col-lg-4 mt-sm-0 mt-2">
                                                <label className="mb-1 font-weight-bold required">Division</label>
                                                <CustomDropDownList
                                                    className={"form-control disabled "}
                                                    disabled={true}
                                                    data={this.state.divisions}
                                                    name={`divisionId`}
                                                    textField="name"
                                                    valueField="id"
                                                    id="divisions"
                                                    defaultItem={defaultItem}
                                                    value={this.state.division==AllRateCard.NAME?AllRateCard.ID:this.state.divisionId}
                                                />
                                                {formikProps.errors.divisionId && <ErrorComponent message={formikProps.errors.divisionId} />}
                                            </div>
                                            <div className="col-12 col-sm-4 col-lg-4 mt-sm-0 mt-2">
                                                <label className="mb-1 font-weight-bold required">{LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")}</label>
                                                <CustomDropDownList
                                                    className="form-control disabled"
                                                    name={`locationId`}
                                                    disabled={true}
                                                    data={this.state.locations}
                                                    textField="name"
                                                    valueField="id"
                                                    id="locations"
                                                    defaultItem={defaultItem}
                                                    value={this.state.location==AllRateCard.NAME?AllRateCard.ID:this.state.locationId}
                                                />
                                                {formikProps.errors.locationId && <ErrorComponent message={formikProps.errors.locationId} />}
                                            </div>
                                        </div>
                                        <div className="row mt-2 mx-0">
                                            <div className="col-12 col-sm-4 col-lg-4 mt-sm-0 mt-0">
                                                <label className="mb-1 font-weight-bold required">Job Category</label>
                                                <CustomDropDownList
                                                    className={"form-control disabled "}
                                                    data={this.state.jobCategories}
                                                    disabled={true}
                                                    name="jobCategory"
                                                    //name={`jobCategoryId`}
                                                    textField="name"
                                                    valueField="id"
                                                    id="jobCategories"
                                                    defaultItem={defaultItem}
                                                    value={this.state.jobCategory==AllRateCard.NAME?AllRateCard.ID:this.state.jobCategoryId}
                                                />
                                                {formikProps.errors.jobCategoryId && <ErrorComponent message={formikProps.errors.jobCategoryId} />}
                                            </div>
                                            <div className="col-sm-4 text-box-disbaled mt-sm-0 mt-2">
                                                <label className="mb-1 font-weight-bold required">Position</label>
                                                <CustomDropDownList
                                                    className="form-control disabled"
                                                    disabled={true}
                                                    name={`positionId`}
                                                    data={this.state.positions}
                                                    textField="name"
                                                    valueField="id"
                                                    id="positions"
                                                    defaultItem={defaultItem}
                                                    value={this.state.position==AllRateCard.NAME?AllRateCard.ID:this.state.positionId}
                                                />
                                                {formikProps.errors.positionId && <ErrorComponent message={formikProps.errors.positionId} />}
                                            </div>
                                            <div className="col-sm-4 mt-sm-0 mt-2">
                                                <label className="mb-1 font-weight-bold required">Service Category</label>
                                                <CustomDropDownList
                                                    className="form-control disabled"
                                                    name={`serviceTypeId`}
                                                    disabled={true}
                                                    data={this.state.serviceCategory}
                                                    textField="name"
                                                    valueField="id"
                                                    id="serviceCategory"
                                                    defaultItem={defaultItem}
                                                    value={this.state.serviceCategoryId}
                                                />
                                                {formikProps.errors.serviceCategoryId && <ErrorComponent message={formikProps.errors.serviceCategoryId} />}
                                            </div>

                                        </div>
                                        <div className="row mt-2 mx-0">
                                            <div className="col-sm-4 text-box-disbaled mt-sm-0 mt-0">
                                                <label className="mb-1 font-weight-bold required">Service Type</label>
                                                <CustomDropDownList
                                                    className="form-control disabled"
                                                    disabled={true}
                                                    name={`serviceTypeId`}
                                                    data={this.state.serviceTypes}
                                                    textField="name"
                                                    valueField="id"
                                                    id="serviceTypes"
                                                    defaultItem={defaultItem}
                                                    value={this.state.serviceTypeId}
                                                />
                                                {formikProps.errors.serviceTypeId && <ErrorComponent message={formikProps.errors.serviceTypeId} />}
                                            </div>
                                            <div className="col-sm-4 mt-sm-0 mt-2">
                                                <label className="mb-1 font-weight-bold required">Bill Type</label>
                                                <CustomDropDownList
                                                    className="form-control disabled"
                                                    name={`billTypeId`}
                                                    data={this.state.billTypes}
                                                    textField="name"
                                                    valueField="id"
                                                    id="billTypes"
                                                    defaultItem={defaultItem}
                                                    value={this.state.billTypeId}
                                                    onChange={(e) => this.handleDropdownChange(e)}
                                                    filterable={this.state.originalbillTypes.length > 5 ? true : false}
                                                    onFilterChange={this.handleFilterChange}
                                                />
                                                {formikProps.errors.billTypeId && <ErrorComponent message={formikProps.errors.billTypeId} />}
                                            </div>
                                            <div className="col-sm-4 mt-sm-0 mt-2" id="removemargin-border">
                                                <label className="mb-1 font-weight-bold required">Max. Bill Rate</label>
                                                <NumericTextBox
                                                    className="form-control text-right"
                                                    name="maxBillrate"
                                                    placeholder="Enter Amount"
                                                    value={isNaN(this.state.maxBillRate) ? 0 : this.state.maxBillRate}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            maxBillRate: event.target.value,
                                                            suppressionAmount: this.state.suppress == undefined ? 0 : (this.state.suppress / 100) * event.target.value
                                                        });
                                                    }}
                                                    title="Maximum value could be 99999."
                                                    max={99999}
                                                    min={0}
                                                    format="c2"
                                                />
                                                {formikProps.errors.maxBillRate && <ErrorComponent message={formikProps.errors.maxBillRate} />}
                                            </div>
                                        </div>

                                        <div className="row mt-2 mx-0">
                                            <div className="col-12 col-sm-4 col-lg-4 mt-2 mt-sm-0">
                                                <label className="mb-1 font-weight-bold ">% Suppress</label>
                                                <NumericTextBox
                                                    className="form-control text-right"
                                                    name="supress"
                                                    placeholder="Enter Percentage"
                                                    value={isNaN(this.state.suppress) || this.state.suppress == null ? 0 : this.state.suppress}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            suppress: event.target.value == undefined ? 0 : event.target.value,
                                                            suppressionAmount: event.target.value == undefined ? 0 : (event.target.value / 100) * this.state.maxBillRate
                                                        });
                                                    }}
                                                    title="Maximum value could be 99."
                                                    max={99}
                                                    min={0}
                                                    format="#.##"
                                                />
                                                {formikProps.errors.suppress && <ErrorComponent message={formikProps.errors.suppress} />}
                                            </div>
                                            <div className="col-12 col-sm-4 col-lg-4  mt-2 mt-sm-0 area-merged">
                                                <label className="mb-1 font-weight-bold">Suppress Amount</label>
                                                <NumericTextBox
                                                    className="form-control text-right"
                                                    name="supressionAmount"
                                                    placeholder="Enter Amount"
                                                    value={isNaN(this.state.suppressionAmount) ? 0 : this.state.suppressionAmount}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            suppressionAmount: event.target.value == undefined ? 0 : event.target.value,
                                                            suppress: event.target.value == undefined ? 0 : (event.target.value / this.state.maxBillRate) * 100
                                                        });
                                                    }}
                                                    title="Maximum value could be 99999."
                                                    max={99999}
                                                    min={0}
                                                    format="c2"
                                                />
                                            </div>
                                            <div className="col-12 col-sm-4 col-lg-4  mt-2 mt-sm-0 area-merged">
                                                <label className="mb-1 font-weight-bold">Target Rate</label>
                                                <NumericTextBox
                                                    className="form-control text-right"
                                                    disabled={true}
                                                    name="supressionAmount"
                                                    placeholder="Enter Amount"
                                                    value={isNaN(this.targetRate) ? this.state.maxBillRate : this.targetRate}
                                                    title="Maximum value could be 99999."
                                                    max={99999}
                                                    min={0}
                                                    format="c2"
                                                    spinners={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="row mt-2 mx-0">
                                            <div className="col-sm-4 mt-sm-0 mt-2" id="removemargin-border">
                                                <label className="mb-1 font-weight-bold required">Max. Holiday Bill Rate</label>
                                                <NumericTextBox
                                                    className="form-control text-right"
                                                    name="maxHolidayBillRate"
                                                    placeholder="Enter Amount"
                                                    value={isNaN(this.state.maxHolidayBillRate) ? 0 : this.state.maxHolidayBillRate}
                                                    onChange={(event) => {
                                                        this.setState({ maxHolidayBillRate: event.target.value });
                                                    }}
                                                    title="Maximum value could be 99999."
                                                    max={99999}
                                                    min={0}
                                                    format="c2"
                                                />
                                                {formikProps.errors.maxHolidayBillRate && <ErrorComponent message={formikProps.errors.maxHolidayBillRate} />}
                                            </div>
                                            <div className="col-sm-4" id="ShowDatePickerIcon">
                                                <label className="mb-1 font-weight-bold">Valid From</label>
                                                <DatePicker
                                                    className="form-control"
                                                    disabled={true}
                                                    format="MM/dd/yyyy"
                                                    name="validFrom"
                                                    value={this.state.validFrom ? new Date(this.state.validFrom) : null}
                                                    onChange={(event) => {
                                                        this.setState({ validFrom: event.target.value });
                                                    }}
                                                    formatPlaceholder="formatPattern"
                                                />
                                                {formikProps.errors.validFrom && <ErrorComponent message={formikProps.errors.validFrom} />}
                                            </div>
                                            <div
                                                className="col-12 col-sm-4 col-lg-4  mt-2 mt-sm-0"
                                                style={{
                                                    display: this.state.rateCardId
                                                        ? "block"
                                                        : "none",
                                                }}
                                            >
                                                <label className="mb-1 font-weight-bold ">
                                                    Tags
                                                </label>
                                                <TagControl
                                                    defaultText="None"
                                                    entityId={this.state.rateCardId}
                                                    entityTypeId={EntityTypeId.CLIENT}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )}

                                <div className="modal-footer justify-content-center border-0 mt-3 mb-3">
                                    <div className="row mt-2 mb-2 ml-0 mr-0 justify-content-center">
                                        <button type="button" className="btn button button-close mr-2 shadow mb-2 mb-xl-0" onClick={this.props.onCloseModal}>
                                            <FontAwesomeIcon icon={faTimesCircle} className={"mr-1"} /> Close
                                        </button>
                                        <button type="submit" className="btn button button-bg mr-2 shadow mb-2 mb-xl-0" onClick={() => this.setState({ submitted: true })}>
                                            <FontAwesomeIcon icon={faSave} className={"mr-1"} /> Save
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        )}
                    />
                </div>
            </div>
        );
    }
}
export default EditClientRateCard;